import { Component, OnInit} from '@angular/core';
import { ContractSearchService } from '../Services/contract-search.service';

@Component({
  selector: 'search-contract-header',
  templateUrl: './search-contract-header.component.html',
  styleUrls: [],
})
export class SearchContractHeaderComponent implements OnInit {

    private _searchText: string;
    get searchText(): string {
        return this._searchText;
    }
    set searchText(value: string) {
        this._searchText = value;
    }
    filterMetadata = { count: 0 };
    index = { count: 0 };
    contractAdminLink: string;
    contractAdminLinkText: string;
    searchTextPlaceholder: string;

    constructor(private dataService: ContractSearchService) { }

    ngOnInit(): void {
        this.dataService.getCurrentPosition$.subscribe((position) => {
            this.index.count = position;
        });

        this.dataService.getTotalSearchCount$.subscribe((count) => {
            this.filterMetadata.count = count;
        });

        this.dataService.getContractAdminLink$.subscribe((link) => {
            this.contractAdminLink = link;
        });

        this.dataService.getContractAdminLinkText$.subscribe((text) => {
            this.contractAdminLinkText = text;
        });

        this.dataService.getSearchTextPlaceholder$.subscribe((text) => {
            this.searchTextPlaceholder = text;
        });
    }

    onTextChange(text) {
        this.dataService.modifyString(text);
    }

    public findNext() {
        this.dataService.setPosition(1);
    }

    public findPrev() {
        this.dataService.setPosition(-1);
    }

    toggleAllSections(event) {
        this.dataService.setToggleEvent(event);
    }
}
